import React from 'react';
import { SessionProvider } from './Session';
import { RevalidateProvider } from './Revalidate';
export const Provider = ({ children, onValidateSession, initialState, }) => {
    return (React.createElement(SessionProvider, { initialState: initialState },
        React.createElement(RevalidateProvider, { onValidateSession: onValidateSession }, children)));
};
//# sourceMappingURL=Provider.js.map